import React from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import withStyles from '@material-ui/core/styles/withStyles';

import FormLabel from '@material-ui/core/FormLabel';
import LinearProgress from '@material-ui/core/LinearProgress';

import { auth } from 'services/Auth';

const styles = theme => ({
  main: {
    width: 'auto',
    display: 'block', // Fix IE 11 issue.
    marginLeft: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 3,
    [theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
      width: 400,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: theme.spacing.unit * 8,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
  },
  progress: {
    width: '100%',
  },
  avatar: {
    margin: theme.spacing.unit,
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing.unit,
  },
  formLabel: {
    fontSize: 12,
  },
  submit: {
    marginTop: theme.spacing.unit * 3,
  },
});



class SignIn extends React.Component {
  constructor(props) {
    super(props);
    const { classes } = props;
    this.state = {
      username: "",
      password: "",
      failed: false,
      loggedIn: Boolean(localStorage.getItem('accessToken')),
      loading: false
    };

  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }

  handleSubmit = async  _ => {
    const { username, password } = this.state;
    const { location } = this.props;


    this.setState({ loading: true, failed: false });
    const authResonse = await auth.login({
      username,
      password,
      originalUrl: location.state ? location.state.from : "/admin",
      onError: (e) => {
        this.setState({ loading: false, failed: e.data.message });
        return;
      }
    });
    this.setState({ loading: false })
  };



  validateForm() {
    return this.state.username.length > 0 && this.state.password.length > 0;
  }

  render() {
    const { classes } = this.props;
    const { loading, failed } = this.state;
    return (
      <section>
        {loading && <LinearProgress className={classes.progress} />}
        <main className={classes.main}>
          <CssBaseline />

          <Paper className={classes.paper}>
            <Avatar src={process.env.PUBLIC_URL + "/krikey-icon.png"} className={classes.avatar}>
              <LockOutlinedIcon />
            </Avatar>

            <Typography component="h1" variant="headline">
              Sign in
          </Typography>
            {failed &&
              <FormLabel error={true} className={classes.formLabel}>
                {failed}
              </FormLabel>
            }
            <form className={classes.form} onSubmit={this.handleSubmit}>
              <FormControl margin="normal" required fullWidth>
                <InputLabel htmlFor="username">Username</InputLabel>
                <Input
                  id="username"
                  name="username"
                  autoComplete="username"
                  autoFocus
                  onChange={this.handleChange}
                />
              </FormControl>
              <FormControl margin="normal" required fullWidth>
                <InputLabel htmlFor="password">Password</InputLabel>
                <Input
                  name="password"
                  type="password"
                  id="password"
                  autoComplete="current-password"
                  onChange={this.handleChange}
                />
              </FormControl>

              <Button
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
                disabled={!this.validateForm()}
                onClick={this.handleSubmit}
              >
                Sign in
              </Button>
            </form>
          </Paper>
        </main>
      </section>
    );
  }
}

SignIn.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SignIn);